"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitTypeEnum = void 0;
var SplitTypeEnum;
(function (SplitTypeEnum) {
    SplitTypeEnum["SPLIT"] = "SPLIT";
    SplitTypeEnum["ITEM"] = "ITEM";
    SplitTypeEnum["LINE_ITEM"] = "LINE_ITEM";
})(SplitTypeEnum || (exports.SplitTypeEnum = SplitTypeEnum = {}));
